import React from 'react';

function IVTherapy() {
  return (
    <div>
      <h2>IV Therapy</h2>
      <p>Our IV therapy services ensure efficient and safe treatment...</p>
    </div>
  );
}

export default IVTherapy;
